import React, { useEffect, useState } from "react";
import axios from "axios";
import { Line } from "react-chartjs-2";
import { Chart as ChartJS, LineElement, PointElement, CategoryScale, LinearScale, Tooltip, Legend, ChartOptions } from "chart.js";
import { useNavigate } from "react-router-dom";
import TableAspirasiSummary from "./tableSummaryAspirasi";
import AspirasiBerandaSkeleton from "../../../../Components/loading/skeletonBeranda";

ChartJS.register(LineElement, PointElement, CategoryScale, LinearScale, Tooltip, Legend);

const AspirasiBeranda = () => {
  const [summary, setSummary] = useState({
    total_aspirasi: 0,
    total_sudah_dijawab: 0,
    total_belum_dijawab: 0,
  });

  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchSummary = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/aspirasi-summary`);
      setSummary(res.data);
    } catch (err) {
      console.error("Gagal fetch aspirasi summary:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSummary();
  }, []);

  if (loading)
    return (
      <div>
        <AspirasiBerandaSkeleton />
      </div>
    );

  // Data untuk Line Chart
  const data = {
    labels: ["Aspirasi"], // cukup 1 label statis
    datasets: [
      {
        label: "Sudah Dijawab",
        data: [summary.total_sudah_dijawab],
        borderColor: "#36A2EB",
        backgroundColor: "#36A2EB",
        tension: 0.4,
      },
      {
        label: "Belum Dijawab",
        data: [summary.total_belum_dijawab],
        borderColor: "#FF6384",
        backgroundColor: "#FF6384",
        tension: 0.4,
      },
    ],
  };

  const options: ChartOptions<"line"> = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
      },
    },
    scales: {
      x: {
        grid: { display: false },
      },
      y: {
        beginAtZero: true,
        ticks: { precision: 0 },
      },
    },
  };

  // ✅ fungsi navigasi berdasarkan filter
  const handleNavigate = (filter?: string) => {
    if (filter) {
      navigate(`/dashboard/beranda/aspirasiAll?status=${filter}`);
    } else {
      navigate(`/dashboard/beranda/aspirasiAll`);
    }
  };

  return (
    <>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* --- Summary Cards --- */}
        <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4">
          {/* Sudah Dijawab */}
          <div onClick={() => handleNavigate("sudah")} className="bg-white p-6 rounded-lg shadow flex flex-col justify-between cursor-pointer hover:shadow-lg transition">
            <h2 className="text-gray-600 text-start">Aspirasi Sudah Dijawab</h2>
            <p className="text-4xl font-bold text-start text-blue-600">{summary.total_sudah_dijawab}</p>
          </div>

          {/* Belum Dijawab */}
          <div onClick={() => handleNavigate("belum")} className="bg-white p-6 rounded-lg shadow flex flex-col justify-between cursor-pointer hover:shadow-lg transition">
            <h2 className="text-gray-600 text-start">Aspirasi Belum Dijawab</h2>
            <p className="text-4xl font-bold text-start text-red-500">{summary.total_belum_dijawab}</p>
          </div>

          {/* Total Semua */}
          <div onClick={() => handleNavigate()} className="bg-white p-6 rounded-lg shadow flex flex-col justify-between lg:col-span-2 cursor-pointer hover:shadow-lg transition">
            <h2 className="text-gray-600 text-start">Total Aspirasi Masyarakat</h2>
            <p className="text-4xl font-bold text-start text-gray-800">{summary.total_aspirasi}</p>
          </div>
        </div>

        {/* --- Chart --- */}
        <div className="bg-white p-6 rounded-lg shadow flex flex-col items-center">
          <h2 className="text-lg font-bold mb-4">Perbandingan Aspirasi</h2>
          <div className="w-full max-w-lg">
            <Line data={data} options={options} />
          </div>
        </div>
      </div>

      <div className="mt-5">
        <TableAspirasiSummary />
      </div>
    </>
  );
};

export default AspirasiBeranda;
